/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment'
import 'moment/locale/pt';
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grow,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  TextField,
  Typography,
} from '@mui/material';
import CustomizedTables from '../../components/Table';
import PaginationRounded from '../../components/NewPagination';
import FilterModal from "./components/filterModal"
import ChangeYieldAmountModal from "./components/changeYieldAmountModal"
import ChangedAmountYieldListModal from "./components/changedAmountYieldListModal"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import axios from 'axios';
import api from '../../services/api';
import { Exception } from 'sass';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../services/apiBase';
import FixedContainer from '../../components/Container';

import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const SearchCupons = ({liquidate}) => {
  const navigate = useNavigate()

  const [openAlert, setOpenAlert] = useState(false);
  const [changeYield, setChangeYield] = useState({});
  const [changeYieldList, setChangeYieldList] = useState([]);
  const [openEditYieldAmount, setOpenEditYieldAmount] = useState(false);
  const [openChangedYieldListModal, setOpenChangedYieldListModal] = useState(false);

  const [alertYield, setAlertYield] = useState({});

  const [loading, setLoading] = useState(false);
  const [cupons, setCupons] = useState(null);
  const [error, setError] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [totalPages, setTotalPages] = useState(0);

  // Liquidate
  const [liquidateLoading, setLiquidateLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedYields, setSelectedYields] = useState([]);
  const [selectedYieldsCustody, setSelectedYieldsCustody] = useState({
    brpNovaFutura: [],
    novaFutura: [],
    outros: []
  });

  // Filter.
  const [filter, setFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [filterValues, setFilterValues] = useState('');

  const anchorRef = useRef(null);
  const [openNew, setOpenNew] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  
  const COLUMNSTABLE = [
    {
      headerName: 'N. da CPR',
      type: 'default',
      value: {  
        first: {
          value: 'cpr_number'
        }
      }
    },
    {
      headerName: 'N.F. Id',
      type: 'default',
      value: {  
        first: {
          value: 'nova_futura_id'
        }
      },
      noData: '---'
    },
    {
      headerName: 'N. do cupom',
      type: 'default',
      value: {
        first: {
          value: 'current_installment'
        },
      }
    },
    {
      headerName: 'Valor',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr_installment'
        }
      }
    },
    {
      headerName: 'Data inicial',
      type: 'date',
      value: {
        first: {
          value: 'date_start'
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'date',
      value: {
        first: {
          value: 'date_end'
        }
      }
    },
    {
      headerName: 'Dias úteis',
      type: 'default',
      value: {
        first: {
          value: 'business_day'
        }
      }
    },
    {
      headerName: 'Atualizado em:',
      type: 'date',
      value: {
        first: {
          value: 'updated_at'
        }
      }
    },
    {
      headerName: 'Pago em:',
      type: 'date',
      value: {
        first: {
          value: 'payment_date'
        }
      },
      noData: 'Pendente'
    },
    {
      headerName: 'Investidor',
      type: 'default',
      value: {
        first: {
          value: 'name'
        }
      },
      noData: 'faltando'
    },
    {
      headerName: 'CPF',
      type: 'CPF',
      value: {
        first: {
          value: 'document_number'
        }
      },
      noData: 'faltando'
    },
    {
      headerName: 'Custodia',
      type: 'default',
      value: {
        first: {
          value: 'investor_custody'
        }
      },
      noData: 'faltando'
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
  ]

  const handleOpenDetails = (cpr) => {
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

  const handleClearFilter = () => { 
    setFilter(false)
    setFilterValues('')
    setCupons([])
    handleSelectAllYields(false)
  }

  const formatDate = (date) => {
    return moment(new Date(date)).format('DD/MM/YYYY')
  }

  const handleCloseAlertYield = () => {
    setOpenAlert(false)
  };

  // handle the amount change for liquidate yield
  const handleChangeYieldAmount = (newValue) => {
    cupons.forEach(function (item) {
      if (item.id === changeYield.id) {
        item.old_amount_cpr_installment = item.amount_cpr_installment
        item.amount_cpr_installment = parseFloat(newValue)
        
        let yields = [];
        yields = selectedYields;

        if (yields.find(x => x === item.id)) {
          yields.splice(yields.indexOf(item.id), 1);
          setTotalAmount(totalAmount - item.old_amount_cpr_installment)
          setSelectedYields(yields)
        }
      }
    })
  }

  const handleChangeYieldAmortizationAmount = (newValue) => {
    cupons.forEach(function (item) {
      if (item.id === changeYield.id) {
        item.amortization = newValue;
      }
    })
  }

  // Check if the selected yields was changed
  const checkChangedYield = () => {
    let changedList = []
    selectedYields.forEach(function (item) {
      let aux = cupons.find(i => i.id === item)

      if (aux?.old_amount_cpr_installment > 0 ) {
        changedList.push(aux)
      }
    })

    if (changedList.length > 0) {
      setChangeYieldList(changedList)
      setOpenChangedYieldListModal(true)
      return
    }

    liquidateCPR()
  }

  // Select or remove all yields
  const handleSelectAllYields = (select) => {
    let selectedYieldsAux = []
    let totalAmountAux = 0
    if (select) {
      cupons.forEach(function (item) {
        if (!['cdi_bullet', 'cdi_cupom', 'ipca_bullet', 'ipca_cupom'].includes(item.type)) {
          selectedYieldsAux.push(item.id)
          totalAmountAux += item.amount_cpr_installment
          handleCustodyYield(item, true)
        }
      })

      setSelectedYields(selectedYieldsAux)
      setTotalAmount(totalAmountAux)

    } else {
      setSelectedYields([])
      setTotalAmount(0)
      setSelectedYieldsCustody({
        brpNovaFutura: [],
        novaFutura: [],
        outros: []
      })
    }
  }

  // handle the opening of the change yield amount modal
  const handleOpenChangeYieldAmountModal = (row) => {
    setChangeYield(row)
    setOpenEditYieldAmount(true)
  }

  // Check the selected yield type
  const handleSelectYields = (coupon) => {
    if (['cdi_bullet', 'cdi_cupom', 'ipca_bullet', 'ipca_cupom'].includes(coupon.type)) {
      setOpenAlert(true)
      setAlertYield(coupon)
    } else {
      selectYields(coupon)
    }
  }

  // Add selected yield to the custody list
  const handleCustodyYield = (coupon, entry) => {
    if (['BRP', 'NOVA FUTURA', 'FINPEC'].includes(coupon.investor_custody)) {
      let brpNovaFuturaAux = selectedYieldsCustody.brpNovaFutura
      if (entry) {
        brpNovaFuturaAux.push(coupon)
      } else {
        brpNovaFuturaAux.splice(brpNovaFuturaAux.indexOf(coupon.id), 1);
      }
      setSelectedYieldsCustody((previousState) => ({
        ...previousState,
        brpNovaFutura: brpNovaFuturaAux
      }))
    }

    if (['NOVA FUTURA'].includes(coupon.investor_custody)) {
      let novaFuturaAux = selectedYieldsCustody.novaFutura
      if (entry) {
        novaFuturaAux.push(coupon)
      } else {
        novaFuturaAux.splice(novaFuturaAux.indexOf(coupon.id), 1);
      }
      setSelectedYieldsCustody((previousState) => ({
        ...previousState,
        novaFutura: novaFuturaAux
      }))
      return
    }

    if (!['FINPEC', 'BRP', 'NOVA FUTURA'].includes(coupon.investor_custody)) {
      let outrosAux = selectedYieldsCustody.outros
      if (entry) {
        outrosAux.push(coupon)
      } else {
        outrosAux.splice(outrosAux.indexOf(coupon.id), 1);
      }
      setSelectedYieldsCustody((previousState) => ({
        ...previousState,
        outros: outrosAux
      }))
    }
  }

  // Show sum to be liquidated.
  const totalLiquidateAmount = () => {
    if(!liquidate) {
      return;
    }
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        marginBottom: 2
      }}>
        <Box sx={{
          display: 'flex',
          width: '100%',
        }}>
          <Typography 
            variant='h6' 
            sx={{ fontWeight: 500, fontSize: '18px', paddingBottom: 2 }}>
              Valor a ser liquidado: 
          </Typography>
          
          <Typography
            variant='h6'
            sx={{
              fontWeight: 500,
              fontSize: '18px',
              paddingBottom: 2,
              marginLeft: 1,
              color: 'green'
            }}>
            {Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(totalAmount)}
          </Typography>
        </Box>
      </Box>
    )
  }

  // Liquidate process (database update)
  const liquidateCPR = async () => {
    if (selectedYields.length === 0) {
      enqueueSnackbar('É preciso selecionar um ou mais cupons para liquidação!', { variant: 'info' });
      return
    }

    setLiquidateLoading(true)

    try {
      let cpr_yield = {}
      let newValues = []

      if (changeYieldList.length > 0) {
        changeYieldList.forEach(function (item) {
          newValues.push({
            yieldId: item.id,
            amount_cpr_installment: item.amount_cpr_installment,
            amount_cpr_profit: item.amount_cpr_installment,
            amortization: item.amortization
          })
        })
        cpr_yield = {
          yield_list: selectedYields,
          newValues: newValues,
          username: user.username
        }
      } else {
        cpr_yield = {
          yield_list: selectedYields,
          username: user.username
        }
      }
      
      await api.post(`/financial/liquidateCrpYieldList`, cpr_yield);
      enqueueSnackbar('Cupons liquidados!', { variant: 'success' });
      setTotalAmount(0)
      setChangeYieldList([])
      setChangeYield({})
      setFilterValues('');
      setSelectedYields([]);
      searchForCupons();

    } catch (error) {
      enqueueSnackbar('Erro ao liquidar cupons!', { variant: 'error' });
    } finally { 
      setLiquidateLoading(false)
    }
  }

  // Mark cupons you want to pay.
  const checkBoxComponent = (row) => {
    return (
      <Box>
        <Checkbox
          checked={selectedYields.find(x => x === row.id) || false}
          onChange={() => handleSelectYields(row)}
        />
        <Button
          onClick={() => handleOpenChangeYieldAmountModal(row)}
        >
          Alterar valor
        </Button>
      </Box>
    )
  }

  const handleToggle = () => {
    setOpenNew((prevOpen) => !prevOpen);
  };

  const handleCloseNew = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpenNew(false);
  };

  // Display menu item and download the CSV
  const menuItemComponent = (data, name, fileName) => {
    return (
      <MenuItem disabled={data.length === 0}>
        <ExcelFile element={
          <Button variant="contained" sx={{ marginBottom: 1 }}>{name}</Button>
        } filename={fileName}>
          <ExcelSheet data={data} name={fileName}>
            <ExcelColumn label="Investidor" value={(col) => col.name } />
            <ExcelColumn label="CPF_do_investidor" value={(col) => col.document_number } />
            <ExcelColumn label="Custódia" value={(col) => col.investor_custody } />
            <ExcelColumn label="Número_da_CPR" value={(col) => col.cpr_number } />
            <ExcelColumn label="Data_de_assinatura" value={(col) => moment.utc(col.date_signed).format('L')} />
            <ExcelColumn label="Tipo" value={(col) => col.type } />
            <ExcelColumn label="Código_b3" value={(col) => col.cpr_number } />
            <ExcelColumn label="Número_do_cupom" value={(col) => col.current_installment } />
            <ExcelColumn label="Valor_principal" value={(col) => col.amount_cpr_installment} />
            <ExcelColumn label="Juros" value={(col) => col.amount_cpr_profit} />
            <ExcelColumn label="Valor_principal_juros" value={(col) => col.amount_cpr_installment + ' ' + col.amount_cpr_profit} />
            <ExcelColumn label="Data_de_início" value={(col) => moment.utc(col.date_start).format('L')} />
            <ExcelColumn label="Data_final" value={(col) => moment.utc(col.date_end).format('L')} />
          </ExcelSheet>
        </ExcelFile>
      </MenuItem>
    )
  }

  // Display button group for choose the CSV type
  const exportExcelComponent = () => {
    return (
      <>
        <Box sx={{
          display: 'flex',
        }}>
          <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
            <Button onClick={() => handleToggle()}>Exportar CSV</Button>
            <Button
              size="small"
              aria-controls={openNew ? 'split-button-menu' : undefined}
              aria-expanded={openNew ? 'true' : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <ArrowDropDownIcon />
            </Button>
          </ButtonGroup>
          <Popper
            sx={{
              zIndex: 1,
            }}
            open={openNew}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseNew}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      {menuItemComponent(selectedYieldsCustody.brpNovaFutura, 'BRP + nova futura', 'cupons_BRP_nova_futura')}
                      {menuItemComponent(selectedYieldsCustody.novaFutura, 'Nova futura', 'cupons_nova_futura')}
                      {menuItemComponent(selectedYieldsCustody.outros, 'Outros', 'cupons_outros')}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </>
    )
  }

  // Display a error message
  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  // Display a empty message
  const emptyMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          {filter ?
            'Não foram encontrados cupons para o filtro escolhido' :
            liquidate ?
              `Não foram encontrados cupons com data de expiração para hoje: ${formatDate(new Date())}`:
              `Não foram encontrados cupons a serem listados`
           }
          
        </Typography>
      </Box>
    )
  }

  // When select an yield, check the selected yields array and add the amount
  const selectYields = (coupon) => {
    let yields = [];
    yields = selectedYields;

    let couponAmount = coupon.amount_cpr_installment;
    
    if (yields.find(x => x === coupon.id)) {
      yields.splice(yields.indexOf(coupon.id), 1);
      setTotalAmount(totalAmount - couponAmount)
      handleCustodyYield(coupon, false)
    } else {
      yields.push(coupon.id);
      setTotalAmount(totalAmount + couponAmount)
      handleCustodyYield(coupon, true)
    }
    setSelectedYields(yields)
    setOpenAlert(false)
  }

  const addParcels = (cuponList, parcels) => {
    // For some reason I need this constant to read inside of the loop...
    const parcelList = parcels;
    for(let i = 0; i < cuponList.length; ++i) {
      const parcel = parcelList.find((parcel) =>{ 
        if(parcel.cpr_id === cuponList[i].cpr_id) {
          return parcel;
        }
      });
      if(parcel) {
        cuponList[i].current_installment = `${cuponList[i].current_installment}/${parcel.parcels}`;
      }
    }
    setCupons(cuponList);
  }

  // Call the server to search for cupons.
  const searchForCupons = async () => {

    // Create path to call.
    let liquidatePath = liquidate ? '&is_liquidate=true' : '';
    let path = `/getCupons?&limit=${limit}${liquidatePath}${filterValues}`;

    try {
      setLoading(true);
      const response = await GetFetch(`/financial${path}`);
      if(!response) {
        throw new Exception('Could not find cupons');
      }
      addParcels(response.data.result.rows, response.data.parcels)
      setError(false)
      // setCupons(response.data.result.rows);
    } catch (error) {
      console.log(error);
      setError(true)
      setCupons([]);
    }
    setLoading(false);
  }

  const searchByInvestor = () => {
    return (
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
        width: '30%',
        marginRight: '1em',
      }}>
        <FormControl fullWidth>
          <TextField
            fullWidth
            label="Buscar por investidor"
            variant="outlined"
            defaultValue=''
            onChange={event => {
              setFilterValues(`&investor_name=${event.target.value}`);
            }} />
        </FormControl>
      </Box> 
    );
  }

  // Button to pay cupons.
  const buttonCuponPayment = () => {
    return (
      <>
        <Button 
          disabled={liquidateLoading}
          variant="contained" 
          onClick={() => checkChangedYield(selectedYields, user.username)}>
            Pagar cupons selecionados {liquidateLoading ? <CircularProgress sx={{marginLeft: 1}} size={20} color='inherit'/> : ''}
        </Button>
      </>
    );
  }

  // Here you can select what cupons you want to pay.
  const addPaymentSelectToTable = () => {
    if(liquidate) {
      return (
        <Box>
          <CustomizedTables
            data={cupons}
            columns={COLUMNSTABLE}
            options
            action={handleOpenDetails}
            moreOptionsTitle={'Selecionar'}
            moreOptions={checkBoxComponent}
          />
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            paddingTop: 2
          }}>
            <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
          </Box>
        </Box>
      )
    }
  }

  // Buttons related to filter.
  const buttonFilter = () => {
    // If filter is active, we can clear it.
    if(filter) {
      return(
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleClearFilter}>
            Limpar filtros
        </Button>
      );
    }

    // If there are no filters, add one.
    return(
      <Button 
        variant="contained" 
        onClick={handleOpen}>
          Filtros
      </Button>
    );
  }

  // Buttons related to filter.
  const buttonSelectAllItems = () => {
    // If filter is active, we can clear it.
    if(selectedYields.length > 0) {
      return(
        <Button 
          variant="contained"
          color="error"
          onClick={() => handleSelectAllYields(false)}>
            Remover selecionados
        </Button>
      );
    }

    // If there are no filters, add one.
    return(
      <Button 
        variant="contained"
        onClick={() => handleSelectAllYields(true)}>
          Selecionar todos
      </Button>
    );
  }

  // Here are the buttons on the far right of the screen.
  const buttonRow = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginY: 2
      }}>
        {searchByInvestor()}
        <Box sx={{display: 'flex', gap: 1}}>
          {buttonFilter()}
          {liquidate && buttonCuponPayment()}
          {liquidate && buttonSelectAllItems()}
          {exportExcelComponent()}
        </Box>
      </Box>
    )
  }

  // Render the table.
  const tableComponent = () => {
    if(loading) {
      return loadingThePage()
    }
    if(error) {
      return errorMessage()
    }
    if(cupons === null) {
      return <></>;
    }
    if(cupons.length === 0) {
      return emptyMessage()
    }
    if(liquidate) {
      return addPaymentSelectToTable();
    }
    return(
      <Box>
        <CustomizedTables
          data={cupons}
          columns={COLUMNSTABLE}
          options
          action={handleOpenDetails}
        />
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          paddingTop: 2
        }}>
          <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
        </Box>
      </Box>
    );
  }

  // To display when the page is still loading.
  const loadingThePage = () => {
    return(
      <Box className='loadingPage'>
        <CircularProgress/>
      </Box> 
    );
  }

  // Title to display on the top of the page.
  const pageTitle = () => {
    if (liquidate) {
      return <><h1>Liquidar Cupons</h1></>
    }
    return <><h1>Procurar Cupons</h1></>
  }

  // Pop up window for filtering search.
  const filterWindow = () => {
    return (
      <>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <FilterModal
            setFilterValues={setFilterValues}
            onClose={handleClose}
            setFilter={setFilter}
            clearCupons={() => setCupons([])}
          />
        </Modal>

        <Modal
          open={openEditYieldAmount}
          onClose={() => setOpenEditYieldAmount(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ChangeYieldAmountModal
            onClose={() => setOpenEditYieldAmount(false)}
            cupon={changeYield}
            changeYieldAmount={handleChangeYieldAmount}
            setAmortization={handleChangeYieldAmortizationAmount}
          />
        </Modal>

        <Modal
          open={openChangedYieldListModal}
          onClose={() => setOpenChangedYieldListModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ChangedAmountYieldListModal
            onClose={() => setOpenChangedYieldListModal(false)}
            cupon={changeYield}
            yieldsList={changeYieldList}
            liquidateCPR={liquidateCPR}
          />
        </Modal>

        <Dialog
          open={openAlert}
          fullWidth={true}
          maxWidth={"sm"}
          onClose={() => setOpenAlert(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Atenção"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {`O cupom selecionado é do tipo:`}
              <Box sx={{display: 'flex', flexDirection: 'column', margin: 2}}>
                <Typography>cdi_bullet ou</Typography>
                <Typography>cdi_cupom ou</Typography>
                <Typography>ipca_bullet ou</Typography>
                <Typography>ipca_cupom</Typography>
              </Box>
            <Typography>Por favor, confirme o valor do cupom: {Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(alertYield?.amount_cpr_installment)}</Typography>
            
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={() => handleCloseAlertYield()}>Cancelar</Button>
            <Button disabled={loading} onClick={() => selectYields(alertYield)} autoFocus>
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  const pageBody = () => {
    return(
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          {pageTitle()}
          {buttonRow()}
          {totalLiquidateAmount()}
          {tableComponent()}
        </Box>
      </FixedContainer>
    );
  }

  useEffect(() => {
    searchForCupons();
  }, [filterValues, liquidate]);

  moment.locale('pt')

  return (
    <>
      {pageBody()}
      {filterWindow()}
    </>
  );

}

export default SearchCupons;
